import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment.prod";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class VendorsService {


  constructor(private http: HttpClient) {}


    //   getVendors(data:any) {
    //     return this.http.get<any>(`${environment.api}/api/admin/vendors`,
    //     {params:data} 
    //     );
    // }

      getVendors(data:any) {
        return this.http
          .get<any>(`${environment.api}/api/customer/vendors`, {
            params: data,
          })
          .catch((error: any) => {
            return Observable.throw(error.error || "vendors Error");
          });
        // return this.http.get<any>(`${environment.api}/api/customer/vendors`);

  }
}
